import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://d21f5663db71cc4c293c404620df7421@o469653.ingest.us.sentry.io/4506963324174336",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});